// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__140UT","containerItemsCenter":"Skeleton_containerItemsCenter__2BKT6"};